<template>
    <div>
        <base-header class="mt-4 pb-6" type=""/>
        <b-container fluid class="mt--6">
            <div><loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/></div>
            <div>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col>
                                    <h3>{{language_terms['BANK_RECONCILIATION']}}</h3>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col md="1">
                                <base-input :label="language_terms['BANK_ACCOUNT']">
                                    <el-select v-model="filter.bankaccount_id" filterable @change="onClickSearch()">
                                        <el-option v-for="item in bankaccounts" 
                                            :key="item.code"
                                            :label="item.code"
                                            :value="item.id"/>
                                    </el-select>
                                </base-input>
                            </b-col>
                            <b-col md="2">
                                <base-input :label="language_terms['DATE']">
                                    <flat-picker slot-scope="{focus, blur}"
                                        @on-change="onClickSearch()"
                                        v-model="filter.date_to"
                                        @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker"/>
                                </base-input>
                            </b-col>
                            <b-col md="1">
                                <base-input :label="language_terms['CURRENCY']" :value="currency_code" disabled/>
                            </b-col>

                            <b-col md="2">
                                <base-input label="Month Opening" :value="(bankaccount.amount_month_open * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled v-if="bankaccount != null"/>
                            </b-col>
                            <b-col md="2">
                                <base-input label="Add Receipts" :value="(bankaccount.amount_month_in * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled v-if="bankaccount != null"/>
                            </b-col>
                            <b-col md="2">
                                <base-input label="Less Payments" :value="(bankaccount.amount_month_out * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled v-if="bankaccount != null"/>
                            </b-col>
                            <b-col md="2">
                                <base-input label="Month Closing" :value="(bankaccount.amount_month_close * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled v-if="bankaccount != null"/>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            
            <b-row v-if="filter.bankaccount_id != null && items.length > 0">
                <b-col lg="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col lg="11">
                                        <h3>Bank Transactions</h3>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row class="mt--4 mb-6"  v-if="items.length > 0">
                                <b-col cols="12" class="mt-3">
                                    <b-table-simple hover responsive>
                                        <b-thead head-variant="light">
                                            <b-th>{{language_terms['SNO']}}</b-th>
                                            <!-- <b-th></b-th> -->
                                            <b-th>Statement Date</b-th>
                                            <b-th>Doc Date</b-th>
                                            <b-th>{{language_terms['DOC_#']}} </b-th>
                                            <b-th>Paid / Received</b-th>
                                            <b-th>{{language_terms['AMOUNT']}}</b-th>
                                            <b-th>Balance</b-th>
                                            <b-th>{{language_terms['ACCOUNT']}} </b-th>
                                            <!-- <b-th>{{language_terms['ACTION']}}</b-th> -->
                                        </b-thead>
                                        <b-tbody>
                                            <tr v-for="(row, i) in items" :key="i" @click="onClickRow(row, i)">
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{i + 1}}</td>
                                                <!-- <td :style="{'font-weight': row.is_reconciled == 1 ? 'normal' : 'bolder'}">{{row.is_reconciled}}</td> -->
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.date_reconciled == null ? '-' : row.date_reconciled}}</td>
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.date}}</td>
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.code}}{{ row.receipt_reference != null && row.receipt_reference != '' ? ' / ' + row.receipt_reference : ''}}</td>
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.contact_name}}</td>
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.amount ? (row.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}) : ''}}</td>
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.rolling_balance ? (row.rolling_balance * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}) : ''}}</td>
                                                <td :style="{'font-weight': row.is_reconciled == 1 ? 'bolder' : 'normal'}">{{row.account_code_name}}</td>
                                                
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>
            </div>
            <div class="floating-bar" style="height:115px; width:1200px; background-color:#AFBFDF" v-if="bankaccount != null">
                    <div class="floating-bar-container">
                        <b-row class="ml-5 mt-2 mb-2">
                            <b-col md="3">
                                <base-input label="Bank Statement Balance" :value="(bankaccount_statement_balance * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled/>
                            </b-col>
                            <b-col md="3">
                                <base-input label="Unreconciled In" :value="(bankaccount.amount_unreconciled_in * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled/>
                            </b-col>
                            <b-col md="3">
                                <base-input label="Unreconciled Out" :value="(bankaccount.amount_unreconciled_out * 1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })" disabled/>
                            </b-col>
                            <b-col md="1" class="mt-4">
                                <b-button variant="success" @click="onClickUpdate()" class="mt-2">
                                    {{ language_terms['UPDATE'] }}
                                </b-button>
                            </b-col>
                            <b-col md="1" class="mt-4">
                                <b-button variant="info" @click="onClickPrint()" class="mt-2">
                                    {{ language_terms['PRINT'] }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </div>

        </b-container>
        
    </div>
</template>
<style>
div.sticky {
    z-index: -1;
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    background-color: #666;
    padding: 40px;
    font-size: 25px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import {Table,TableColumn,Select, Option } from "element-ui";
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css"; 
import BaseInput from '../../components/Inputs/BaseInput.vue';
import moment from "moment";

export default
{
    computed:{
        bankaccount_statement_balance()
        {
            this.updateSummary()
            return (this.bankaccount.amount_month_open * 1) + this.amount_reconciled_in + this.amount_reconciled_out
        },
        ...mapState({
            language_terms: state => state.languages.language_terms,
            is_created: state => state.contactCategories.is_created,
            is_updated: state => state.contactCategories.is_updated,
            is_deleted: state => state.contactCategories.is_deleted,
            contact_categories: (state) => state.contactCategories.contact_categories,
        })
    },
    components:{
        Loading,
        flatPicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,        
    },
    data(){
        return{
            amount_reconciled_in: 0,
            amount_reconciled_out: 0,
            selectedVendor:null,
            selectedCustomer:null,
            customers:[],
            vendors:[],
            currency_code: 'SGD',
            reconcile:{
                bankaccount_transaction_id: null,
                amount_transaction: null,
                amount_reconciled: null,
                contact_type: null,
                contact_id: null,
                items:[],
            },            
            loadingCounter:0,
            ritems:[],
            items:[],
            filter:{
                reference: null,
                document: null,
                date_to: null,
            },
            currency_options:[],
            bankaccount: null,
            bankaccounts:[],
            reconciled_options:[
                {
                    label: "All",
                    value: null
                },
                {
                    label: "Unreconciled",
                    value: 0
                },
                {
                    label: "Reconciled",
                    value: 1
                },
            ],
            mode_options:[
                {
                    label:"Debit",
                    value:'DB'
                },
                {
                    label:"Credit",
                    value:'CR'
                },
            ],
            type_options:[
                {
                    label:"Debtor",
                    value:'DB'
                },
                {
                    label:"Creditor",
                    value:'CR'
                },
            ],
            row:{
                id:null,
                bankaccount_id:null,
                amount_credit:null,
                amount_debit:null,
                mode:null,
                date:null,
                currency_code:null,
                amount:null,
                reference1:null,
                reference2:null,
                reference3:null,
                reference4:null,
                reconciled_source:null,
                reconciled_id:null,
                is_reconciled:null,
                time_reconciled:null,
                time_created:null,
            },
            total_cr_amount:null,
            total_db_amount:null,
        }
    },
    async mounted()
    {
        this.filter.date_to = moment().format("YYYY-MM-DD")
        this.loadingCounter++
        const d = new Date()
        d.setMonth(d.getMonth() + 0);
        
        this.loadDefaultOptions()
        this.loadBankAccounts()
        this.loadingCounter--
    },
    methods:{
        async onClickPrint()
        {
            let url = 'https://reports.unityerp.com/esteam/bank-recon/' + encodeURIComponent(localStorage.access_token)
            + '/' + encodeURIComponent(this.bankaccount.id)
            window.open(url , '_blank');
        },
        async onClickUpdate()
        {
            let url = apiRoutes["BANKACCOUNTS_RECON_UPDATE"]
            let payload = {items: this.items}
            // alert(url)
            await axios.post(url, payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.onClickSearch()
                    Vue.notify({ text: response.data.msg, type: 'success', group: 'notify', max: 5, duration: 5000, speed: 300 })
                } else {
                    Vue.notify({ text: response.data.msg, type: 'error', group: 'notify', max: 5, duration: 5000, speed: 300 })
                }

            })
            .catch((error) => {
            if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
            }
            });
            
            
        },
        async updateReconciledAmount()
        {
            let amount = 0

            this.reconcile.items.forEach((i, index) => {
                if (i.is_selected)
                {
                    amount += (i.amount * 1)
                }
            })
            this.reconcile.amount_reconciled = amount
        },
        // async retrieveUnpostedReceipts()
        // {
        //     let url = apiRoutes["BANK_ACCOUNTS_RETRIEVE_UNPOSTED_RECEIPTS"]
        //     let payload = this.reconcile
        //     // alert(url)
        //     await axios.post(url, payload, authHeader()).then((response) => {
        //     if (response.data.code == 1) {
        //         this.reconcile.items = response.data.data;
        //     } else {
        //         this.reconcile.items = [];
        //     }

        //     })
        //     .catch((error) => {
        //     if (error.response) {
        //         Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
        //     }
        //     });
        // },
        limitText(count)
        {
            return `and ${count} others`;
        },
        async loadDefaultOptions()
        {
            // let payload = []
            // await axios
            // .post(apiRoutes["CURRENCIES_LIST"], payload, authHeader())
            // .then((response) => 
            // {
            //     if (response.data.code == 1) {
            //         this.currency_options = response.data.data
            //     } 
            //     else 
            //         Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
            
            // })
            // .catch((error) => {
            //     if (error.response) {
            //         Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            //     }
            // });
        },
        async loadBankAccounts()
        {
            let payload = []
            await axios
            .post(apiRoutes["BANK_NAME_LIST"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.bankaccounts = response.data.data
                } 
                else 
                    Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});

            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });
        },
        async updateSummary()
        {
            // Re-Calculate Unreconciled Summary Total
            let amount_unreconciled_in = 0
            let amount_unreconciled_out = 0
            this.amount_reconciled_in = 0
            this.amount_reconciled_out = 0

            this.items.forEach((item, index) => {
                item.is_reconciled = parseInt(item.is_reconciled)
                item.amount = parseFloat(item.amount)
                if (item.amount > 0)
                {
                    if (!item.is_reconciled)
                        amount_unreconciled_in += item.amount
                    else
                        this.amount_reconciled_in += item.amount
                }
                else
                {
                    if (!item.is_reconciled)
                        amount_unreconciled_out += item.amount
                    else
                        this.amount_reconciled_out += item.amount
                }  
            })

            this.bankaccount.amount_unreconciled_in = amount_unreconciled_in
            this.bankaccount.amount_unreconciled_out = amount_unreconciled_out
        },
        async onClickRow(row, i)
        {
            let is_reconciled = parseInt(this.items[i].is_reconciled) ? 0 : 1
            
            this.items[i].is_reconciled = is_reconciled
            if (is_reconciled)
                this.items[i].date_reconciled = this.filter.date_to
            else
                this.items[i].date_reconciled = null

            this.updateSummary()
        },
        async onClickSearch()
        {
            this.loadingCounter++
            let url = apiRoutes["BANK_ACCOUNTS_RETRIEVE_TRANSACTIONS"]
            let payload = this.filter
            // alert(url)
            await axios
            .post(url, payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.bankaccount = response.data.data.bankaccount
                    this.currency_code = response.data.data.bankaccount.currency_code
                    this.items = response.data.data.transactions
                    this.reconcile.currency_code = this.filter.currency_code
                } 
            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });                
            this.loadingCounter--
        },
        async onClickDelete(row)
        {
            this.loadingCounter++
            let payload = {id:row.id}
            await axios
            .post(apiRoutes["BANK_ACCOUNTS_DELETE_TRANSACTION"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.onClickSearch()
                } 
            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });                
            this.loadingCounter--
        },
    }
}

</script>